export const MIN_SUSPEND = 7;

export const MAX_SUSPEND = 124;
